export default __webpack_public_path__ + "static/media/Zeston-Dashboard2.10bfa472.jpg";